import { Container } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
import useLocales from "src/hooks/useLocales";
import useTabs from "src/hooks/useTabs";
import { AppType } from "src/types/apps";

import ApiClient from "./ApiClient/ApiClient";
import ApiSecrets from "./ApiSecrets/ApiSecrets";
import Customization from "./Customization/Customization";
import AppDetails from "./Details/AppDetails";
import EmptyApp from "./EmptyApp/EmptyApp";
import PolicyConfiguration from "./PolicyConfiguration/PolicyConfiguration";
import SettingsTab from "./SettingsTab";

// ----------------------------------------------------------------------

export const AppSettings = () => {
	const { currentTab, onChangeTab } = useTabs("app_details");
	const { data: apps } = useQuery<AppType[]>({
		queryKey: ["apps"],
		initialData: []
	});

	const { translate } = useLocales();

	if (apps.length === 0) {
		return (
			<Page title='Ajustes app'>
				<Container maxWidth={"xl"}>
					<EmptyApp />
				</Container>
			</Page>
		);
	}

	return (
		<Page title={translate("app_settings.title")}>
			<Container maxWidth={"xl"}>
				<PageHeader title={translate("app_settings.title")} back={false} />
				<SettingsTab onChangeTab={onChangeTab} currentTab={currentTab} />
				{currentTab === "app_details" && <AppDetails />}
				{currentTab === "api_security" && <ApiSecrets />}
				{currentTab === "api_client" && <ApiClient />}
				{currentTab === "customization" && <Customization />}
				{currentTab === "configuration" && <PolicyConfiguration />}
			</Container>
		</Page>
	);
};

export default AppSettings;
